import React from "react";
import Locale from "../Locale";
import Util from "../Util";
import {
  buildCanonicalHref,
  normalizePagePath,
  normalizeSeoLocale,
} from "./canonicalUrl";

export default function Alternate({ lang, resolvedUrl, domain }) {
  const origin = Util.getOrigin(domain, { seo: true });
  const pagePath = normalizePagePath(resolvedUrl);
  const pathSuffix = pagePath === "/" ? "" : pagePath;

  return (
    <>
      {Locale.localeList.map((obj) => {
        const hrefLang = normalizeSeoLocale(obj.key);
        return (
          <link
            key={obj.key}
            rel="alternate"
            href={`${origin}/${hrefLang}${pathSuffix}`}
            hrefLang={hrefLang}
          />
        );
      })}
      <link
        rel="alternate"
        href={`${origin}/en${pathSuffix}`}
        hrefLang="x-default"
      />
      <link
        rel="canonical"
        href={buildCanonicalHref({ lang, pagePath, domain })}
      />
    </>
  );
}
